import LayoutScreen from '../../components/layout';
import CapturePage from '../../components/CapturePage';
import iconArrowLeft from '../../assets/icon/icon_arrow_left.svg';
import { useNavigate } from 'react-router-dom';
import useGuid from '../../components/hook/useGuid';
import { useContext, useEffect } from 'react';
import { ProfileContext } from '../../components/context/profileContext';

const PageCapture = (props) => {
  const { profile } = useContext(ProfileContext);
  const { limitCredit } = useGuid();
  const navigate = useNavigate();

  const handleBack = () => {
    navigate('/biodata'); // Programmatically navigate to /new-route
  };

  useEffect(() => {
    if(profile){

    }
    else{
      if(limitCredit <= 0 && !profile){
        handleBack();
      }
    }
  }, [profile, limitCredit])



  return (
    <LayoutScreen>
      <div className="relative flex flex-col flex-grow h-full px-5 p-5 md:p-10">
        <div className="h-full flex flex-col flex-grow justify-between items-center">
          <div className=" w-full flex space-x-4 justify-between items-start">
            <div
              onClick={() => handleBack()}
              className="w-full cursor-pointer flex space-x-2 md:space-x-4 justify-start items-center">
              <img
                src={iconArrowLeft}
                alt="icon arrow left"
                className="w-5 h-5 md:w-8 md:h-8 object-contain"
              />
              <div className=" w-full md:text-2xl font-semibold text-textBlack">
                Ambil Gambar
              </div>
            </div>
          </div>

          <div className="flex flex-grow justify-center items-center w-full">
            <CapturePage />
          </div>
        </div>
      </div>
    </LayoutScreen>
  );
};

export default PageCapture;
